import { App } from 'App';
import './services/http';
import 'app.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { unregister as unregisterServiceWorker } from 'registerServiceWorker';
import store from 'store/store';
import { StyleSheetManager } from 'styled-components';

// Suppress benign ResizeObserver loop error (triggered by Toast UI editor and other libs)
const resizeObserverErr = (e: ErrorEvent) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation();
  }
};
window.addEventListener('error', resizeObserverErr);

ReactDOM.render(
  <Provider store={store}>
    <StyleSheetManager disableVendorPrefixes>
      <App />
    </StyleSheetManager>
  </Provider>,
  document.getElementById('root'),
);

// Disable service worker to avoid aggressive client-side caching
unregisterServiceWorker();
